import React, { useState, useEffect, useRef } from 'react'
import { DateTime } from 'luxon'
import { connect } from 'react-redux'
import { fetchPlaylistsIfNeeded, invalidatePlaylists } from '../actions'
import { zedPlayerPlay } from '~/player/actions'
import { hmsToSecondsOnly } from '~/helpers'

const TrackData = (props) => {

  const { onairnow, playlist, dispatch, episode, selectedProgramSlug } = props;
  const [ trackURL, setTrackURL ] = useState(null);

  const testRef = useRef();

  useEffect(() => {

    var timer;
    if(onairnow && episode) {
      timer = setInterval( getNowPlaying , 120000);
      // getNowPlaying();
    }
    return () => { 
      if(onairnow && episode) { 
        clearInterval(timer) 
      }
    }
  }, [props.episode.start]);

  useEffect(() => {
    console.log('new trackdata instance')
    testRef.current = props.episode.start;
  }, [])

 


  const getNowPlaying = () => {
    const { dispatch, episode, selectedProgramSlug } = props;
    console.log('fetching tracks', selectedProgramSlug, episode.start)
    dispatch(invalidatePlaylists(selectedProgramSlug, episode.start))
    dispatch(fetchPlaylistsIfNeeded(selectedProgramSlug, episode.start))
  }

  const playOnDemand = (time) => {
    const { dispatch, episode, program } = props
    

    var show = episode.start
    console.log(show)
    var showt = show.split(' ');
    var ondemandEp = showt[0] + '-' + showt[1].split(':')[0];

    let ondemandSrc = null
    if (program.program.defaultFirstAiredGuide === 'fm' || program.program.guideId === 'fm'){
      ondemandSrc = '//undead.4zzz.fm/4zzz/'+ ondemandEp + '-00.mp3'
    }
    else {
      ondemandSrc = '//undead.4zzz.fm/zed-digital/ZD-' + ondemandEp + '-00.mp3'
    }

    //const ondemandSrc = '//barry.4zzz.org.au:8001/live.nsv'
    
    // var zedPlayer = videojs('zed-live')
    // if(!zedPlayer.paused()){
    //   zedPlayer.pause()
    // }
    // zedPlayer.src({type: 'audio/mp3', src: ondemandSrc})
    // //zedPlayer.tech_.el_.children[0].src = ondemandSrc
    // zedPlayer.play()

    if (time) {
      var realtime;
      //  if (moment(this.props.episode.start).format('a') === 'pm') {
      //      realtime = moment(this.props.episode.start.split(' ')[0] + ' ' + time).add(12, 'hours').format('HH:mm:ss')
      //  } else {
      //      realtime = moment(this.props.episode.start.split(' ')[0] + ' ' + time).format('HH:mm:ss')
      //  } 
      if (DateTime.fromSQL(episode.start).hour >= 12 ) {
        realtime =  DateTime.fromFormat(time + ' PM', 'tt').toLocaleString(DateTime.TIME_24_WITH_SECONDS) 
      }
      else {
        realtime =  DateTime.fromFormat(time + ' AM', 'tt').toLocaleString(DateTime.TIME_24_WITH_SECONDS) 
      }
      // aproxtime = aprox.split(' ')[1];
       var contexttime = episode.start.split(' ')[1];
       var seconds = Math.abs(hmsToSecondsOnly(realtime) - hmsToSecondsOnly(contexttime))

       dispatch(zedPlayerPlay({type: 'audio/mp3', src: ondemandSrc}, seconds))

      //  zedPlayer.on('loadedmetadata' , function() {
      //    this.currentTime(seconds)
      //  })

       console.log(seconds)
    }
    else { 
      dispatch(zedPlayerPlay({type: 'audio/mp3', src: ondemandSrc}))
    }
  }



    if ( playlist && playlist.items?.length > 0 ) {

      const tracks = playlist.items

      if (onairnow){
        tracks.reverse()
      }
      return(
        <div className="playlist">
        {tracks.map((track, index) =>
          <div style={{pointerEvents: 'all'}} className="track" key={index}>
            { onairnow && track.time ? <span className="track-time">{track.time}</span> : null }
            <span className="track-artist">{track.artist}</span>
            <span className="track-title">{track.track}</span>{track.release ? <span className="track-release">{track.release}</span> : null }
            { (track.contentDescriptors.isLocal) ? <span style={{float: 'right'}} className="track-locality">LOCAL</span> : ( track.contentDescriptors.isAustralian ) ? <span style={{float: 'right'}} className="track-locality">AUS</span> : null }
            { onairnow ? null : (track.time) ? <span onClick={() => playOnDemand(track.time)} className="track-locality play"><i className="fa fa-play"></i> {track.time}</span> : null }
            <div dangerouslySetInnerHTML={{ __html:track.notes }}></div>
          </div>
        )}
        </div>
      )
    } else { return (null) }
}

export default connect(state => {return { selectedProgramSlug: state.selectedProgramSlug } })(TrackData)
